<template>
    <div class="userpage">
        <van-row class="user_face">
            <van-row class="face_row">
                <van-col span="8">
                    <van-image
                            round
                            width="80px"
                            height="80px"
                            :src="user.avatar"
                    />
                </van-col>
                <van-col span="16">
                    <van-row class="user_name">
                       <router-link to="Login">{{user.username}}</router-link>
                    </van-row>
                    <van-row class="uesr_level">
                        <van-icon name="vip-card" /> VIP{{user.level}}
                    </van-row>
                </van-col>
            </van-row>
            <van-row class="user_money">
                <van-row class="mtitle">
                    <van-col span = "6">
                        {{ $t("me.amount") }}($)
                    </van-col>
                    <van-col span = "6"></van-col>
                    <van-col span = "6">{{ $t("me.frozen") }}</van-col>
                    <van-col span = "6" @click="hiddmoney"><van-icon name="eye" /></van-col>
                </van-row>
                <van-row class="money">
                    <van-col span = "12" >
                        {{ this.isDispay?"******": user.amount||0 }}
                    </van-col>
                    <van-col span = "12" >
                        {{ this.isDispay?"******":user.frozen||0 }}
                    </van-col>
                </van-row>
            </van-row>
        </van-row>
        <van-row class="cangyong">
            <van-col span="4.8" class="mgico">
                <router-link to="Recharge">
                    <van-row  class="cyico"><van-icon name="bill" color="red"/></van-row>
                    <van-row class="icotitle">{{ $t("me.icotitle1") }}</van-row>
                </router-link>
              </van-col>
            <van-col span="4.8" class="mgico">
                <router-link to="Withdrawal">
                    <van-row  class="cyico"><van-icon name="card" color="#ff9900"/></van-row>
                    <van-row class="icotitle">{{ $t("me.icotitle2") }}</van-row>
                </router-link>
            </van-col>
            <van-col span="4.8" class="mgico">
                <router-link to="Recharge">
                    <van-row  class="cyico"><van-icon name="service" color="#1989FA"/></van-row>
                    <van-row class="icotitle">{{ $t("me.icotitle3") }}</van-row>
                </router-link>
            </van-col>
            <van-col span="4.8" class="mgico">
                <router-link to="Financial">
                    <van-row  class="cyico"><van-icon name="todo-list" color="#FF976A"/></van-row>
                    <van-row class="icotitle">{{ $t("me.icotitle4") }}</van-row>
                </router-link>
            </van-col>
            <van-col span="4.8" class="mgico">
                <router-link to="Message">
                    <van-row  class="cyico"><van-icon name="smile-comment" color="#ff9900"/></van-row>
                    <van-row class="icotitle">{{ $t("me.icotitle5") }}</van-row>
                </router-link>
            </van-col>
        </van-row>
        <van-row class="bananr">
            <van-image class="banimg"
                    width="100%"
                    height="100%"
                    fill
                    radius="10"
                    :src="user.bananr"
            />
        </van-row>
        <van-row class="grolink">
            <van-col span="24">
                <van-cell-group inset>
                    <router-link to="UserInfo"><van-cell :title="$t('me.linktitle1')" icon="info" is-link/></router-link>
                    <router-link to="Recharge"><van-cell :title="$t('me.icotitle1')" icon="bill" is-link/></router-link>
                    <router-link to="Withdrawal"><van-cell :title="$t('me.icotitle2')" icon="card" is-link/></router-link>
                    <router-link to="Financial"><van-cell :title="$t('me.icotitle4')" icon="balance-list" is-link/></router-link>
                    <router-link to="My_investment"><van-cell :title="$t('me.linktitle2')" icon="gem" is-link/></router-link>
                    <router-link to="Proxycen" v-if="proxyuser"><van-cell :title="$t('me.linktitle7')" icon="cluster" is-link/></router-link>
                    <router-link to="Share"><van-cell :title="$t('me.linktitle3')" icon="share" is-link/></router-link>
                    <router-link to="Message"><van-cell :title="$t('me.linktitle4')" icon="comment" is-link/></router-link>
                    <router-link to="App_down"><van-cell :title="$t('me.linktitle5')" icon="star" is-link/></router-link>
                    <van-cell is-link :title="$t('me.linktitle6')" icon="weapp-nav" @click="show = true" />
                    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
                </van-cell-group>
            </van-col>
        </van-row>
        <van-row class="logout">
            <van-col span="24">
                <van-button type="primary" block class="btn" color="linear-gradient(to right, #ff6034, #ee0a24)" @click="logout">{{ $t("me.logout") }}</van-button>
            </van-col>
        </van-row>
        <Bottom_comp></Bottom_comp>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Bottom_comp from '@/components/Bottom_comp.vue'
import Footer from '@/components/Footer.vue'
import {getReq} from "../utils/api";
    export default {
        name: "Me",
        data(){
            return {
                user:[],
                isDispay:false,
                show:false,
                actions: [{ name: '简体中文' }, { name: 'English' }, { name: 'Deutsch' }],
                proxyuser : 0,
            }
        },
        mounted(){
            this.getuserinfo();
        },
        components:{
            Header,
            Bottom_comp,
            Footer
        },
        methods:{
            hiddmoney(){
                this.isDispay=!this.isDispay
            },
            getuserinfo(){
                getReq('/userInfo','').then((res)=>{
                    if(res.code==200){
                        this.user = res.data;
                        this.$store.commit('setUser',res.data);
                        this.proxyuser = this.user.isproxy=='是'?true:false;
                    }
                })
            },
            logout(){
                this.$dialog.confirm({
                    title: this.$t('me.jstitle'),
                    message: this.$t('me.jscom'),
                }).then(() => {
                         window.localStorage.removeItem('tokenStr');
                         this.$router.replace('/Login');
                    }).catch(() => {
                        // on cancel
                    });
            },
            onSelect(item) {
                // 默认情况下点击选项时不会自动收起
                // 可以通过 close-on-click-action 属性开启自动收起
                this.show = false;
                this.$toast(item.name);
                switch (item.name) {
                    case '简体中文':
                        window.localStorage.setItem('lang','cn');
                        this.$i18n.locale = 'cn';
                        break;
                    case 'English':
                        window.localStorage.setItem('lang','en');
                        this.$i18n.locale = 'en';
                        break;
                    case 'Deutsch':
                        window.localStorage.setItem('lang','de');
                        this.$i18n.locale = 'de';
                        break;
                    default:
                        window.localStorage.setItem('lang','cn');
                        break;
                }
            },
        }
    }
</script>

<style scoped lang="scss">
.userpage{
    color: #666;
    background: #EEEEEE;
    padding-top: 20px;
    margin: 0 0 30px 0;
    /*对多出的部分隐藏，并显示...*/
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    .user_face{
        width: 92%;
        height: 180px;
        background:url("~@/assets/images/bg_fund.png");
        background-size: 100% 100%;
        margin: 0 auto 10px auto;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);

        .face_row{
            margin: 0 auto 15px auto;
            padding-top: 15px;
        }
        .user_name{
            font-size: 22px;
            font-weight: bold;
        }
        .uesr_level{
            height: 35px;
            line-height: 35px;
            color: #e6f31b;
            font-size: 16px;
        }
        .user_money{
            .mtitle{
                text-align: left;
                text-indent: 15px;
                height: 18px;
                line-height: 18px;
            }
            .money{
                text-align: left;
                text-indent: 15px;
                height: 35px;
                line-height: 35px;
                color: white;
                font-size: 19px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }
    .cangyong{
        height: 80px;
        width: 92%;
        margin: 0 auto;
        border-radius: 10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        background: white;
        text-align: center;
        display: flex;
        color: #999;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;


            .mgico{
                margin: 15px auto;
                a{
                    color: #666666;

                .cyico{
                    font-size: 30px;

                }
              }
            }
        .icotitle{
            font-size: 10px;
        }
    }
    .bananr{
        width: 92%;
        height: 100px;
        margin: 16px auto;
        background: #fff;
        border-radius:10px;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        .banimg{
            border-radius: 10px;
        }
    }
    .grolink{
        text-align: left;
        padding-bottom: 20px;
    }
    .logout{
        width: 92%;
        margin: 10px  auto;
    }

}
</style>
